export const mfaTypes = {
  SMS: 'SMS_MFA',
  TOTP: 'SOFTWARE_TOKEN_MFA',
  NOMFA: 'NOMFA',
};
